import { render, staticRenderFns } from "./EditPrices.vue?vue&type=template&id=2fdfa9d6&"
import script from "./EditPrices.vue?vue&type=script&lang=js&"
export * from "./EditPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports